import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { useSelector } from 'react-redux';
import { getShouldUseBreezeCompanyInfo } from '../utils/getShouldUseBreezeCompanyInfo';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
export const useInSidePanelLayoutExperiment = () => {
  const {
    isAssignedToVariant: getIsAssignedToVariantACQ173
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const shouldShowSidePanel = useSelector(getShouldShowSidePanel);
  const shouldUseBreezeCompanyInfo = getShouldUseBreezeCompanyInfo();
  const isAssignedToVariantACQ173 = getIsAssignedToVariantACQ173();
  return {
    isInSidePanelLayoutExperiment: shouldUseBreezeCompanyInfo || shouldShowSidePanel || isAssignedToVariantACQ173
  };
};